import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './routes';
import { fetchStoreInfo } from './lib/store';
import './index.css';

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    fetchStoreInfo();
  }, []);

  return (
    <StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </HelmetProvider>
    </StrictMode>
  );
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// Ensure we only create the root once
let root: ReturnType<typeof createRoot>;
if (!(rootElement as any)._reactRoot) {
  root = createRoot(rootElement);
  (rootElement as any)._reactRoot = root;
} else {
  root = (rootElement as any)._reactRoot;
}

root.render(<App />);